import React from 'react';
import '../styles/Aboutme.css';
import '../styles/AnimatedText.css';
import { motion } from 'framer-motion';

const AboutMe = () => {

        const text = "products that don’t just look good";
    return (
        <section id="about-me" className="about-me">
            <h2 className="section-title-ab">About me</h2>
            {/*<div className="project-cards">*/}
                <section className="hero-section-ab">
                    <h1>
                        I’m passionate about creating visually stunning <br/>
                        <div className="text-container">
                            {text.split("").map((char, index) => (
                                <span key={index} className="animated-letter" style={{ animationDelay: `${index * 0.1}s` }}>
                                {char === " " ? "\u00A0" : char}
                            </span>
                            ))}
                        </div>
                       <br/>
                        but also genuinely improve and simplify people's quality of life.
                    </h1>
                    {/*</div>*/}
                    <div className="hero-details">
                        <div>
                        <h3>Experience</h3>
                            <p>5 years</p>
                </div>
                <div>
                    <h3>Location</h3>
                    <p>NRW, Germany</p>
                </div>
                <div>
                    <h3>Freelance</h3>
                    <p>Available</p>
                </div>
            </div>
        </section>

        {/* Work Experience Section */}
        {/*<section className="work-experience">*/}
        {/*    <h2>Work Experience</h2>*/}
            {/*<div className="experience-list">*/}
            {/*    <div className="experience-item">*/}
            {/*        <h3>2022—Now</h3>*/}
            {/*        <div>*/}
            {/*            <h4>Pugpig</h4>*/}
            {/*            <p>Lead Product Designer, London, UK</p>*/}
            {/*            <p>Designed a digital publishing platform, focusing on user-centric solutions.</p>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className="experience-item">*/}
            {/*        <h3>2022—Now</h3>*/}
            {/*        <div>*/}
            {/*            <h4>Roqqu</h4>*/}
            {/*            <p>Lead Design Contractor, Lagos, Nigeria</p>*/}
            {/*            <p>Worked on digital asset platforms, crafting seamless user experiences.</p>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    /!* Add other experience items here *!/*/}
            {/*</div>*/}
        {/*</section>*/}

         {/* Testimonials Section */}
        {/*<section className="testimonials">*/}
        {/*    <h2>Testimonials From Peers & Coworkers</h2>*/}
        {/*    <div className="testimonials-grid">*/}
        {/*        /!*<div className="testimonial">*!/*/}
        {/*        /!*    <p>"Jay’s work always amazes me, happy I chose him."</p>*!/*/}
        {/*        /!*    <span>- Spencer Fairhurst, Pugpig</span>*!/*/}
        {/*        /!*</div>*!/*/}
        {/*        /!*<div className="testimonial">*!/*/}
        {/*        /!*    <p>"The best designer at Roqqu, a pleasure to work with."</p>*!/*/}
        {/*        /!*    <span>- Manager, Roqqu</span>*!/*/}
        {/*        /!*</div>*!/*/}
        {/*        /!* Add more testimonials *!/*/}
        {/*    </div>*/}
        {/*</section>*/}

        {/*// /!* Call to Action *!/*/}
        {/*<section className="cta">*/}
        {/*    <h2>Got an idea? Share with me</h2>*/}
        {/*    <p>Ready for a design adventure or need product design advice? Ping me for fun collaboration.</p>*/}
        {/*    <button className="cta-button-aboutme">Drop a message</button>*/}
        {/*</section>*/}
    </section>
);

};
export default AboutMe;